import { useLocalStorage } from 'react-use';
import { useCallback, useEffect } from 'react';

export type LastVisitedProperty = {
  propertyId: string;
  addedOn: number;
};

export const useLastVisitedProperties = (propertyId: string) => {
  const [lastVisitedProperties = [], setLastVisitedProperties] = useLocalStorage<LastVisitedProperty[]>('lastVisitedProperties', []);

  const addLastVisitedProperty = useCallback(
    (propertyId: string) => {
      const newProperty = {
        propertyId,
        addedOn: Date.now(),
      };

      const newLastVisitedProperty = [
        newProperty,
        ...lastVisitedProperties.filter((property) => property.propertyId !== newProperty.propertyId),
      ].slice(0, 15);

      setLastVisitedProperties(newLastVisitedProperty);
    },
    [lastVisitedProperties, setLastVisitedProperties],
  );

  useEffect(() => {
    addLastVisitedProperty(propertyId);
  }, []);

  return {
    lastVisitedProperties,
    addLastVisitedProperty,
  };
};
